// extracted by mini-css-extract-plugin
export default {"fr-view":"Files_fr-view__ilrhw"};